export const config = {
  key: `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAwdJjYv8xKCq8RNBgmgMU
1ySDjNHAVlqk8ODK2YSJinJ4m0hpw2F4ADxTf2qDfyghwSxL9eTyk9cgvc1GpArj
Pw/rkzApTjZL5njtFe0kH/sDXKmb7sWmDEK4ybXd3FJ6RZMQQrtkMtEMw0ZMbQN8
sObFBMbr4f28iedSO1Rr/y4ficfyAfbGU9rVt9gEhWFv0aQSo+CK5upaa9Lxev1p
Mniy0CorHNGNDxPMyFL8eg3W4s6FEDGfsCs//viFeY/2pzxbje3OUL92CRFOtLtK
3rDZWMxYRzKSFOkGdCHu7M7qptHXN5ycpzjiPMVn7wd09D/Cr3wCifdXlHdjjvdc
1ZwvlmFjciKXKYtAYdw6rgpbutQHTRH6VKalrvQiH+u8vXMe8qmmhI8KSydCJ5T7
+/fkTWaCwMEXYdCbSYYI/oHnlMBQQDGpLmcuYNsfcw+9my6EbkB3ORe5R4RpLdBu
8DC0sUl5QL/xrhbCA8FIMgJtd0Zkvb+7hdyHKEadu/O+L6uzCcq7CCsmYJ/TIK4l
XtRNYs/eWhORLE+hq64f2w9CH137NJtmKUSauy7d+y6Oi4EMOUR/O55+nC6LIc4J
PCjf+mXqu6NdgG/33L96un+3oB5rcBfJWfOd4Ip+Y+trDbe7mkHizkMtPXvSJ0lS
2k8dPnBkIGYJi0bzSYTqsRsCAwEAAQ==
-----END PUBLIC KEY-----`,
  endpoint: "https://asia-east2-noq-guru.cloudfunctions.net/noq-pfarm"
};
